export enum Statuses {
    PASSED = 'PASSED',
    FAILED = 'FAILED'
}
